<i18n src="@/locales/modules/DashboardDeviceTranslate.json"></i18n>

<template>
	<div class="list-devices p-6" v-if="$store.state.dashboardManagement.isFetchedDevices">
		<div class="flex flex-wrap flex-col md:flex-row md:flex-no-wrap justify-center md:justify-between header list-devices__header">
			<h4 class="md:flex-grow mb-3 md:mb-0 header__title whitespace-no-wrap">{{ $t("ListDevices") }}</h4>
			<div class="md:flex-grow annotation text-right header__annotation">
				<!-- <ul class="flex flex-col flex-wrap md:flex-row md:justify-end annotation__type" v-if="categories.length">
					<li
						class="flex items-center mr-6 mb-2 last:mr-0"
						v-for="(category, index) in categories"
						:key="index"
					>
						<i :class="`mr-2 nucleo ${category.categoryIcon}`"></i>
						<span class="flex-shrink-0">{{ category.name }}</span>
					</li>
				</ul>
				<ul class="flex flex-col flex-wrap md:flex-row lg:flex-row justify-end annotation__status mt-2" v-if="devicesStatus.length">
					<li class="flex-grow sm:flex-grow-0 flex items-center mr-6 font-medium last:mr-0" v-for="(status, index) in devicesStatus" :key="index">
						<i class="mr-2 nucleo-device-status" :style="{ backgroundColor: status.color }"></i>
						{{ status.name }}
					</li>
				</ul> -->
				<el-tooltip popper-class="bg-orange-100" effect="light" placement="bottom">
					<div slot="content">
						<div class="">
							<div class="grid grid-cols-2 md:grid-cols-4 bg-orange-100" v-if="categories.length">
								<div class="flex items-center mr-6 mb-2 last:mr-0" v-for="(category, index) in categories" :key="index">
									<i :class="`mr-2 nucleo text-xl ${category.categoryIcon}`"></i>
									<p class="text-xl">{{ category.name }}</p>
								</div>
							</div>
						</div>
					</div>
					<i class="nucleo nucleo-ic_info_24px text-3xl cursor-pointer"></i>
				</el-tooltip>
			</div>
		</div>

		<div class="content list-devices__content grid grid-cols-2 md:grid-cols-4 mt-6">
			<div :key="device.id" v-for="device in listDevices" @click.stop="() => viewDetail(device.id)" class="item content__item p-3 mr-4 mb-4 flex items-center overflow-auto sm:overflow-visible">
				<div class="item__shape mr-3 flex" v-if="device.categoryIcon">
					<i :class="`nucleo ${device.categoryIcon} primary text-sm`"></i>
				</div>
				<div class="info item__info h-full">
					<div class="info__code text-black break-all">{{ device.name }}</div>
				</div>
			</div>
		</div>
		<CbsPagination class="mt-3" :total="totalPages" v-model="currentPage" />

		<!-- <div class="test-actions" v-if="isNotProduction">
			<button @click="handleRemove">Remove</button>
			<button @click="handleReset" class="ml-3">Reset</button>
			<button @click="handleChangeSensorData" class="ml-3">ChangeSensorData</button>
		</div> -->

		<device-detail-dialog :isDialogActive="detailDialog" @closeDialog="toggleDetailDialog" :dataId="detailDialogDataId" />
	</div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import DeviceDetailDialog from "./DeviceDetailDialog";
import { Tooltip } from "element-ui";

export default {
	components: {
		DeviceDetailDialog,
		"el-tooltip": Tooltip
	},
	data() {
		return {
			socketData: null,

			detailDialog: false,
			detailDialogDataId: "",

			listDevices: [],
			total: 0,
			currentPage: 1
		};
	},
	computed: {
		...mapGetters({
			getParsedDevices: "dashboardManagement/getParsedDevices",
			getParsedCategories: "dashboardManagement/getParsedCategories"
		}),
		devices() {
			return this.getParsedDevices || [];
		},
		devicesStatus() {
			return _.get(this.$store, "state.dashboardManagement.devicesStatus") || [];
		},
		categories() {
			return (this.getParsedCategories || []).filter(category => category.categoryIcon);
		},
		isNotProduction() {
			return process.env.NODE_ENV !== "production";
		},
		totalPages() {
			return Math.ceil(this.total / 12);
		}
	},
	watch: {
		devices() {
			this.listDevices = this.devices;
		},
		currentPage() {
			this.getListDevices();
		}
	},
	methods: {
		async getListDevices() {
			try {
				this.$vs.loading();
				const queryOptions = {
					limit: 12,
					sensor_has_data: true,
					page: this.currentPage
				};

				const response = await this.$store.dispatch("dashboardManagement/fetchDashboardDeviceListGql", queryOptions);
				this.total = response.totalDevices;
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		viewDetail(deviceId) {
			this.detailDialogDataId = deviceId;
			this.toggleDetailDialog(true);
		},
		toggleDetailDialog(val = false) {
			this.detailDialog = val;
		},
		handleRemove() {
			const temp = [...this.listDevices];
			temp.splice(Math.floor(Math.random() * temp.length), 1);
			this.listDevices = temp;
		},
		handleReset() {
			this.listDevices = this.devices;
		},
		handleChangeSensorData() {
			const filterDevices = this.listDevices.filter(device => device.sensorData.length);
			const randomIndexItem = Math.floor(Math.random() * filterDevices.length);
			const tempItem = _.find(this.listDevices, device => device.id === filterDevices[randomIndexItem].id);
			const randomIndexItemSensorData = Math.floor(Math.random() * tempItem.sensorData.length);
			this.listDevices = this.listDevices.map(device => {
				if (device.id === tempItem.id) {
					device.sensorData[randomIndexItemSensorData].value = Math.floor(Math.random() * Math.floor(10000));
				}
				return device;
			});
		}
	},
	async created() {
		await this.$store.dispatch("dashboardManagement/fetchCategories", {});
		this.getListDevices();
	}
};
</script>

<style lang="scss" scoped>
.list-devices {
	.annotation__type {
		.nucleo {
			display: flex;
			&::before {
				color: var(--color-gray-3);
				font-size: 19px;
				vertical-align: -webkit-baseline-middle;
			}
		}
	}

	.annotation__status {
		.nucleo-device-status {
			display: block;
			width: 24px;
			height: 8px;
		}
	}

	.list-devices__content {
		.item {
			cursor: pointer;
			min-width: 100px;
			border-radius: 4px;
			border: 1px solid #e5e5e5;

			.item__shape,
			.info__sensor {
				transition: var(--common-transition);
			}

			.item__shape {
				.nucleo {
					&::before {
						font-size: 30px;
						vertical-align: -webkit-baseline-middle;
					}
				}
			}
		}
	}
}
</style>
